var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mutate"},[_c('p',{staticClass:"animation",attrs:{"id":"animation"},on:{"mouseover":_vm.animate}},[_vm._v(_vm._s(_vm.active ? "I'm quite a bit larger." : "I'm small."))])])}
var staticRenderFns = []

export { render, staticRenderFns }